export default "__VITE_ASSET__CgI9elA6__"